const removeCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 20 Oct 1994 00:00:00;path=/`;
}

export default removeCookie;
